// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .header-panel {
  background-color: var(--headerBackground);
  color: var(--headerColor);
  position: absolute;
  top: 0px;
  left: 0px;
  height: 40px;
  width: 100%;
  text-align: center;
  line-height: 40px;
  border-bottom: 1px solid var(--headerBorder);
}
:host .header-panel mat-icon {
  display: inline-block;
  vertical-align: text-top;
}
:host .work-panel {
  position: absolute;
  top: 40px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/integrations/node-red/node-red-flows/node-red-flows.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/integrations/node-red/node-red-flows/node-red-flows.component.scss"],"names":[],"mappings":"AACI;EACI,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,4CAAA;ACAR;ADGI;EACI,qBAAA;EACA,wBAAA;ACDR;ADII;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ACFR","sourcesContent":[":host {\n    .header-panel {\n        background-color: var(--headerBackground);\n        color: var(--headerColor);\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        height: 40px;\n        width: 100%;\n        text-align: center;\n        line-height: 40px;\n        border-bottom: 1px solid var(--headerBorder);\n    }\n\n    .header-panel mat-icon {\n        display: inline-block;\n        vertical-align: text-top;\n    }\n\n    .work-panel {\n        position: absolute;\n        top: 40px;\n        left: 0px;\n        right: 0px;\n        bottom: 0px;\n    }\n}",":host .header-panel {\n  background-color: var(--headerBackground);\n  color: var(--headerColor);\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 40px;\n  width: 100%;\n  text-align: center;\n  line-height: 40px;\n  border-bottom: 1px solid var(--headerBorder);\n}\n:host .header-panel mat-icon {\n  display: inline-block;\n  vertical-align: text-top;\n}\n:host .work-panel {\n  position: absolute;\n  top: 40px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
